import React, { createContext, useState } from "react";
import GlobalValuesService from "../services/globalValuesService";

const initialState = {
  loading: false,
  GlobalValues: [],
};

const GlobalValuesContext = createContext();

const GlobalValuesContextProvider = ({ children }) => {
  const [state, setState] = useState(initialState);

  const getAllGlobalValues = async () => {
    setState({ ...state, loading: true });
    const data = await GlobalValuesService.getAllGlobalValues();
    setState({ GlobalValues: data, loading: false });
  };

  const value = { state, setState, getAllGlobalValues };
  return (
    <GlobalValuesContext.Provider value={value}>
      {children}
    </GlobalValuesContext.Provider>
  );
};

const useGlobalValuesContext = () => {
  const context = React.useContext(GlobalValuesContext);
  if (context === undefined) {
    throw new Error(
      "decoMethodsContext must be used within a DecoMethodsContextProvider"
    );
  }
  return context;
};

export { GlobalValuesContextProvider, useGlobalValuesContext };
